var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoomerang(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext5_1",
    x: 0.726562,
    width: 40,
    height: 40,
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ext5_1_i",
    d: "M10.4251 9.69298C11.1306 8.9873 12.1179 8.65602 13.0932 8.77309L23.2306 9.9965C27.1526 10.4735 30.244 13.5659 30.7207 17.4955L31.9509 27.632C32.0778 28.6167 31.7326 29.6037 31.0318 30.3046C29.3215 32.0154 26.3901 31.3035 25.6662 28.9846L22.7106 19.5676C22.4765 18.8256 21.9016 18.2503 21.1599 18.0161L11.7448 15.0595C9.42928 14.3358 8.70583 11.4127 10.4251 9.69298ZM12.9143 10.2624C12.389 10.1994 11.8608 10.3785 11.4859 10.7535C10.5641 11.6755 10.9515 13.2403 12.192 13.6277L12.1931 13.6281L12.8667 13.8396L13.6092 10.3462L12.9143 10.2624ZM15.7418 14.7424L16.5995 10.7071L15.8519 10.6169L15.023 14.5167L15.7418 14.7424ZM19.3357 15.871L21.6106 16.5854C22.8194 16.9668 23.76 17.9076 24.1411 19.1166L24.8551 21.3912L29.5611 20.3909L29.2317 17.6762C28.838 14.4308 26.2862 11.8792 23.0502 11.4856L20.3374 11.1582L19.3357 15.871ZM30.0147 24.1283L25.9831 24.9852L26.2087 25.704L30.1054 24.8757L30.0147 24.1283ZM26.8855 27.8604L27.0981 28.5377C27.4847 29.7763 29.0552 30.1602 29.971 29.2441C30.3499 28.8651 30.53 28.3374 30.463 27.8221L30.4622 27.8158L30.3775 27.1181L26.8855 27.8604Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomerang);
export default __webpack_public_path__ + "static/media/Boomerang.60e5d0cb.svg";
export { ForwardRef as ReactComponent };